import { render, staticRenderFns } from "./OfertaAcademica.vue?vue&type=template&id=53139fa0&"
import script from "./OfertaAcademica.vue?vue&type=script&lang=js&"
export * from "./OfertaAcademica.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports